import { Container, Row, Col } from "react-bootstrap";
import "../../sass/layout/newsletter/newsletter.css";
import { useTranslation } from "react-i18next";
import arrowRight from "../../utils/img/right-arrow2.png";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNewsletter, getTokenMedia } from "../../services/actions/home.action";
import { Mixpanel } from "../../utils/mixpanelIntegration";
import UserService from '../../services/api/UserService';
import FlipBookModal from "../flipbook/FlipBookModal";

export const trackMedicareNewsletterClick = (newsletterData, locationData) => {
  Mixpanel.track("Medicare Newsletter Clicked", {
    isLogged: UserService.isLoggedIn(),
    newsletter: newsletterData?.attributes?.titleForLeftMenu || newsletterData?.titleForLeftMenu || newsletterData?.title,
    currentMedicareNewsletter: newsletterData?.attributes?.current_newsletter || newsletterData?.current_newsletter,
    pdfNameMedicareNewsletter: newsletterData?.attributes?.pdf?.data?.attributes?.name || newsletterData?.pdf?.data?.attributes?.name,
    locationName: locationData?.name,
    isRetireePortal: true
  });
};

const NewsLetter = ({ isRetireePortal = false }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { newsletter } = useSelector((state) => state.homeReducer);
  const { tokenMedia } = useSelector((state) => state.homeReducer);
  const location = useSelector((state) => state.homeReducer.location?.data);
  const [showFlipBook, setShowFlipBook] = useState(false);

  useEffect(() => {
    const fetchNewsletterData = async () => {
      // Fetch fresh access token first
      await getTokenMedia(dispatch);

      // Then fetch newsletter data
      const showIn = isRetireePortal ? 'retireePortals' : 'userPortals';
      await getNewsletter(dispatch, showIn, location?.uniqueNonGuessableId);
    };

    fetchNewsletterData();
  }, [dispatch, isRetireePortal, location?.uniqueNonGuessableId]);

  const handleNewsletterClick = () => {
    if (isRetireePortal) {
      trackMedicareNewsletterClick(newsletter, location);
      setShowFlipBook(true);
    } else {
      Mixpanel.track("Newsletter Clicked", {
        newsletter: newsletter?.title,
        locationName: location?.name,
      });
    }
  };

  return (
    <>
      <Container
        fluid
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          height: "420px",
          width: isRetireePortal ? '98.7%' : '100%'
        }}
      >
        {isRetireePortal ? (
          <div
            className="newsletter-title-a"
            onClick={handleNewsletterClick}
            style={{ cursor: "pointer" }}
          >
            <Row>
              <Col
                style={{
                  padding: "0",
                }}
              >
                <div
                  className="img-newsletter"
                  style={{
                    backgroundImage: `url(${newsletter?.image?.url}?${tokenMedia})`,
                  }}
                >
                  <h3 className="miia-newsletter">
                    {isRetireePortal ? t("newsletter.medicareHeader") : t("newsletter.wellnessHeader")}
                    <img
                      style={{
                        marginTop: "1rem",
                      }}
                      src={arrowRight}
                      alt="arrow-right"
                    ></img>
                  </h3>
                </div>
                <h4 className="newsletter-title">{newsletter?.title}</h4>
              </Col>
            </Row>
          </div>
        ) : (
          <a
            className="newsletter-title-a"
            href={newsletter?.link}
            target="_blank"
            rel="noreferrer"
          >
            <Row onClick={handleNewsletterClick}>
              <Col
                style={{
                  padding: "0",
                }}
              >
                <div
                  className="img-newsletter"
                  style={{
                    backgroundImage: `url(${newsletter?.image?.url}?${tokenMedia})`,
                  }}
                >
                  <h3 className="miia-newsletter">
                    {isRetireePortal ? t("newsletter.medicareHeader") : t("newsletter.wellnessHeader")}
                    <img
                      style={{
                        marginTop: "1rem",
                      }}
                      src={arrowRight}
                      alt="arrow-right"
                    ></img>
                  </h3>
                </div>
                <h4 className="newsletter-title">{newsletter?.title}</h4>
              </Col>
            </Row>
          </a>
        )}
      </Container>

      {isRetireePortal && (
        <FlipBookModal
          show={showFlipBook}
          handleClose={() => setShowFlipBook(false)}
          pdfUrl={`${newsletter?.pdfUrl}?${tokenMedia}`}
          width="100%"
          height="80vh"
          className="retiree-newsletter-flipbook"
        />
      )}
    </>
  );
};

export default NewsLetter;
